export default class Manager {
    constructor(props) {
        this.admin_register_master_id = props.admin_register_master_id
        this.first_name = props.first_name
        this.last_name = props.last_name
        this.access_token = props.access_token || null
    }
}